import { ChevLeftIcon } from '@/components/Icons';
import { Badge } from '@/components/ui/badge';
import { useAudioPlayerStore } from '@/state/audio-player-store';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { cn } from '@/utils';

const BackLastPage: React.FC<{ className?: string }> = ({ className }) => {
  const navigate = useNavigate();
  const { stop } = useAudioPlayerStore();

  return (
    <div className={cn('relative z-10 container mx-auto px-2 flex items-start', className)}>
      <div
        className="flex justify-center items-center gap-2 min-w-fit cursor-pointer"
        onClick={() => {
          stop();
          navigate('/marketplace');
        }}
      >
        <Badge variant="secondary" className="h-[2.5rem] w-[2.5rem] text-[#000] cursor-pointer bg-[#eaeaeb] hover:bg-[#eaeaeb]/80">
          <ChevLeftIcon className="scale-[2]" fillColor="currentColor" />
        </Badge>
        <span className="text-black text-[1rem]">Back</span>
      </div>
    </div>
  );
};

export default BackLastPage;
